import filterAPI from "../api/filterAPI";
import { ActionTypesScreen6 } from "app/constants";

export function fetchCteLeftSunburstScreen6(county, subgroup) {
  return (dispatch) => {
    filterAPI
      .getCTELeftSunburstData({ county: county, subgroup: subgroup })
      .then((res) => {
        let cteLeftSunburstScreen6 = res.data.data;
        dispatch(handleCteLeftSunburstScreen6(cteLeftSunburstScreen6));
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

function handleCteLeftSunburstScreen6(data) {
  return {
    type: ActionTypesScreen6.GET_CTE_LEFT_SUNBURST_SCREEN6,
    payload: data,
  };
}

export function fetchCteRightSunburstScreen6(county, subgroup) {
  return (dispatch) => {
    filterAPI
      .getCTERightSunburstData({ county: county, subgroup: subgroup })
      .then((res) => {
        let cteRightSunburstScreen6 = res.data.data;
        dispatch(handleCteRightSunburstScreen6(cteRightSunburstScreen6));
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

function handleCteRightSunburstScreen6(data) {
  return {
    type: ActionTypesScreen6.GET_CTE_RIGHT_SUNBURST_SCREEN6,
    payload: data,
  };
}

export function fetchCteBarChartScreen6(county, subgroup) {
  return (dispatch) => {
    filterAPI
      .getCTEbarChartData({ county: county, subgroup: subgroup })
      .then((res) => {
        let cteBarChartScreen6 = res.data.data;
        dispatch(handleCteBarChartScreen6(cteBarChartScreen6));
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

function handleCteBarChartScreen6(data) {
  return {
    type: ActionTypesScreen6.GET_CTE_BAR_CHART_SCREEN6,
    payload: data,
  };
}

export function fetchCTEfilterDataScreen6() {
  return (dispatch) => {
    filterAPI
      .getCTEfilterData({})
      .then((res) => {
        let CTEfilterDataScreen6 = res.data.data;
        dispatch(handleCTEfilterDataScreen6(CTEfilterDataScreen6));
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

function handleCTEfilterDataScreen6(data) {
  return {
    type: ActionTypesScreen6.GET_CTE_FILTER_DATA_SCREEN6,
    payload: data,
  };
}

export function fetchAverageDataScreen6(region_name) {
  return (dispatch) => {
    filterAPI
      .getAverageDetailsScreen6({ region_name: region_name })
      .then((res) => {
        let averageDataScreen6 = res.data.data;
        dispatch(handleAverageDataScreen6(averageDataScreen6));
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

function handleAverageDataScreen6(data) {
  return {
    type: ActionTypesScreen6.GET_AVERAGE_DATA_SCREEN6,
    payload: data,
  };
}

export function fetchEducationSummaryDataScreen6(region_name) {
  return (dispatch) => {
    filterAPI
      .getEducationSummaryDetailsScreen6({ region_name: region_name })
      .then((res) => {
        let educationSummaryDataScreen6 = res.data.data;
        dispatch(
          handleEducationSummaryDataScreen6(educationSummaryDataScreen6)
        );
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

function handleEducationSummaryDataScreen6(data) {
  return {
    type: ActionTypesScreen6.GET_EDUCATION_SUMMARY_DATA_SCREEN6,
    payload: data,
  };
}

export function fetchEducationAttainmentDataScreen6(region_name) {
  return (dispatch) => {
    filterAPI
      .getEducationAttainmentDetailsScreen6({ region_name: region_name })
      .then((res) => {
        let educationAttainmentDataScreen6 = res.data.data;
        dispatch(
          handleEducationAttainmentDataScreen6(educationAttainmentDataScreen6)
        );
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

function handleEducationAttainmentDataScreen6(data) {
  return {
    type: ActionTypesScreen6.GET_EDUCATION_ATTAINMENT_DATA_SCREEN6,
    payload: data,
  };
}

export function fetchEducationSummaryCardsScreen6(region_name) {
  return (dispatch) => {
    filterAPI
      .getEducationSummaryCards({ region_name: region_name })
      .then((res) => {
        let educationSummaryCardsScreen6 = res.data.data;
        dispatch(
          handleEducationSummaryCardsScreen6(educationSummaryCardsScreen6)
        );
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

function handleEducationSummaryCardsScreen6(data) {
  return {
    type: ActionTypesScreen6.GET_EDUCATION_SUMMARY_CARDS_SCREEN6,
    payload: data,
  };
}

export function fetchGradPostEducationSummaryScreen6(region_name) {
  return (dispatch) => {
    filterAPI
      .getGradPostEducationSummary({ region_name: region_name })
      .then((res) => {
        let gradPostSummaryScreen6 = res.data.data;
        dispatch(
          handleGradPostEducationSummaryScreen6(gradPostSummaryScreen6)
        );
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

function handleGradPostEducationSummaryScreen6(data) {
  return {
    type: ActionTypesScreen6.GET_GRAD_POST_SUMMARY_SCREEN6,
    payload: data,
  };
}

export function fetchGradPostSubgroupSummaryScreen6(region_name) {
  return (dispatch) => {
    filterAPI
      .getGradPostSubgroupSummary({ region_name: region_name })
      .then((res) => {
        let gradPostSubgroupSummaryScreen6 = res.data.data;
        dispatch(
          handleGradPostSubgroupSummaryScreen6(gradPostSubgroupSummaryScreen6)
        );
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

function handleGradPostSubgroupSummaryScreen6(data) {
  return {
    type: ActionTypesScreen6.GET_GRAD_POST_SUBGROUP_SCREEN6,
    payload: data,
  };
}

export function fetchNAEPTableDataScreen6() {
  return (dispatch) => {
    filterAPI
      .getNAEPTableData()
      .then((res) => {
        let naepTableScreen6 = res.data.data;
        dispatch(
          handleNAEPTableDataScreen6(naepTableScreen6)
        );
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

function handleNAEPTableDataScreen6(data) {
  return {
    type: ActionTypesScreen6.GET_NAEP_TABLE_SCREEN6,
    payload: data,
  };
}

export function fetchCompletionsOverTimeScreen6(region_name) {
  return (dispatch) => {
    filterAPI
      .getCompletionsOverTime({ region_name: region_name })
      .then((res) => {
        let completionsOverTimeScreen6 = res.data.data;
        dispatch(
          handleCompletionsOverTimeScreen6(completionsOverTimeScreen6)
        );
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

function handleCompletionsOverTimeScreen6(data) {
  return {
    type: ActionTypesScreen6.GET_COMPLETIONS_OVER_TIME_SCREEN6,
    payload: data,
  };
}

export function fetchCompletionsByDegreeTypeScreen6(region_name) {
  return (dispatch) => {
    filterAPI
      .getCompletionsByDegreeType({ region_name: region_name })
      .then((res) => {
        let completionsByDegreeTypeScreen6 = res.data.data;
        dispatch(
          handleCompletionsByDegreeTypeScreen6(completionsByDegreeTypeScreen6),
        );
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

function handleCompletionsByDegreeTypeScreen6(data) {
  return {
    type: ActionTypesScreen6.GET_COMPLETIONS_BY_DEGREE_TYPE_SCREEN6,
    payload: data,
  };
}